export default __webpack_public_path__ + "static/media/como-cadastrar-pagina4.65057963.svg";